import { render } from "./PCVistaVolcadoDetallePartida.vue?vue&type=template&id=29ed296a&scoped=true"
import script from "./PCVistaVolcadoDetallePartida.vue?vue&type=script&lang=js"
export * from "./PCVistaVolcadoDetallePartida.vue?vue&type=script&lang=js"

import "./PCVistaVolcadoDetallePartida.vue?vue&type=style&index=0&id=29ed296a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ed296a"]])

export default __exports__